import { useRef, useState, useEffect } from 'react';
import { motion, useReducedMotion } from 'motion/react';

export default function Tabs({ tabs = [], active, onChange }) {
  const reduceMotion = useReducedMotion();
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);
  const containerRef = useRef(null);

  useEffect(() => {
    const idx = tabs.findIndex((t) => t.key === active);
    const el = tabRefs.current[idx];
    if (el && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const rect = el.getBoundingClientRect();
      setIndicator({ left: rect.left - containerRect.left, width: rect.width });
    }
  }, [active, tabs]);

  const handleKeyDown = (e, idx) => {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const next = (idx + 1) % tabs.length;
      onChange(tabs[next].key);
      tabRefs.current[next]?.focus();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const prev = (idx - 1 + tabs.length) % tabs.length;
      onChange(tabs[prev].key);
      tabRefs.current[prev]?.focus();
    }
  };

  return (
    <div ref={containerRef} className="aui-tabs" role="tablist">
      {tabs.map((tab, idx) => (
        <button
          key={tab.key}
          ref={(el) => (tabRefs.current[idx] = el)}
          role="tab"
          aria-selected={active === tab.key}
          className={['aui-tab', active === tab.key ? 'active' : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(tab.key)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          tabIndex={active === tab.key ? 0 : -1}
        >
          {tab.label}
        </button>
      ))}
      {!reduceMotion && (
        <motion.div
          className="aui-tab-indicator"
          style={{
            position: 'absolute',
            bottom: '0.25rem',
            left: indicator.left,
            width: indicator.width,
            height: '2px',
            borderRadius: '2px',
            background: 'var(--neon-cyan)',
          }}
          animate={{ left: indicator.left, width: indicator.width }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        />
      )}
    </div>
  );
}
